import { render } from "./DiscountTypeSelector.vue?vue&type=template&id=33dd8666"
import script from "./DiscountTypeSelector.vue?vue&type=script&lang=js"
export * from "./DiscountTypeSelector.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/mwon.net/gugar.mwon.net/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__